import { CSSProperties } from 'react';
import { SvgProps } from '@/components/icons/svg';

export interface HomePickupProps extends SvgProps {
  ariaTitle?: string;
}

export default function HomePickup({ s }: { s?: CSSProperties }) {
  return (
    <svg
      width="42"
      height="40"
      viewBox="0 0 42 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...s, verticalAlign: 'middle' }}
    >
      <path
        d="M32.3834 32.1045C34.0205 32.1045 35.3477 30.7773 35.3477 29.1402C35.3477 27.5031 34.0205 26.1759 32.3834 26.1759C30.7463 26.1759 29.4191 27.5031 29.4191 29.1402C29.4191 30.7773 30.7463 32.1045 32.3834 32.1045Z"
        stroke="black"
        strokeWidth="0.8"
      />
      <path
        d="M34.3506 20.5264H28.5881C28.3771 20.526 28.1748 20.4419 28.0258 20.2926C27.8767 20.1433 27.793 19.9409 27.793 19.7299V14.2561C27.793 14.0452 27.8767 13.8429 28.0259 13.6938C28.175 13.5447 28.3772 13.4609 28.5881 13.4609H31.1269C31.3083 13.4607 31.4868 13.5057 31.6464 13.592C31.8059 13.6782 31.9414 13.8029 32.0406 13.9548L35.5015 18.3991C35.6369 18.6065 35.7138 18.8467 35.724 19.0943C35.7342 19.3418 35.6774 19.5875 35.5595 19.8054C35.4416 20.0233 35.2671 20.2053 35.0543 20.3322C34.8415 20.4591 34.5984 20.5262 34.3506 20.5264V20.5264Z"
        stroke="black"
        strokeWidth="0.8"
      />
      <path
        d="M8.1406 7.50171L5.05914 10.738L8.195 13.9882"
        stroke="black"
        strokeWidth="0.8"
        strokeLinecap="round"
      />
      <path
        d="M5.50558 10.6361L25.7171 10.6124H31.1881C31.611 10.6125 32.0282 10.7106 32.4067 10.8992C32.7853 11.0878 33.1149 11.3616 33.3698 11.6991L39.5857 19.9391L40.0767 20.4747C40.6723 21.1207 41.0021 21.9676 41.0002 22.8462V26.5595C41.0002 27.2066 40.7431 27.8272 40.2856 28.2847C39.828 28.7423 39.2075 28.9993 38.5604 28.9993H35.2488"
        stroke="black"
        strokeWidth="0.8"
      />
      <path d="M14.1624 28.7105H29.4916" stroke="black" strokeWidth="0.8" />
      <path
        d="M8.02467 28.7566H3.56082"
        stroke="black"
        strokeWidth="0.8"
        strokeLinecap="round"
      />
      <path
        d="M17.1145 23.4558H6.51285"
        stroke="black"
        strokeWidth="0.8"
        strokeLinecap="round"
      />
      <path
        d="M12.4286 20.0731L1 20.0731"
        stroke="black"
        strokeWidth="0.8"
        strokeLinecap="round"
      />
      <path
        d="M11.1774 32.1045C12.8146 32.1045 14.1417 30.7773 14.1417 29.1402C14.1417 27.5031 12.8146 26.1759 11.1774 26.1759C9.54032 26.1759 8.21317 27.5031 8.21317 29.1402C8.21317 30.7773 9.54032 32.1045 11.1774 32.1045Z"
        stroke="black"
        strokeWidth="0.8"
      />
    </svg>
  );
}
